const { strToBool } = require("../helper");

$('[data-toggle="collapse"]').on("click", function () {
  const element = $(this);
  const control = element.attr("aria-controls");
  const parent = element.closest('[role="tablist"]');

  if (strToBool(parent.attr("aria-multicollapse")) === false) {
    parent.find("div.collapse.in[id!=" + control + "]").each(function () {
      $(this).collapse("hide");
    });
  }
});
